
import React, { Fragment } from 'react';

// Components

import EmployerCoverageDetails from './EmployerCoverageDetails';
import SummaryFilter from '../SummaryFilter';
import SummaryItem from '../SummaryItem';

// Constants

import { getOptionsForHardcodedState } from '../../../../../../constants/ssap/hhmTypes/dropdownOptions';

// Types

import { SsapSummaryType } from '../../../../../../components/ssap/SsapTypes';



const EmployerCoverageInfo = props => {
    
    const {
        applicantGuid,
        applyingForCoverageIndicator,
        employerSponsoredCoverage,
        healthCoverage: {
            employerWillOfferInsuranceIndicator,
            stateHealthBenefit
        },
        householdMembers,
        idx,
        previousData,
        state
    } = props;
    
    if(!applyingForCoverageIndicator) {
        return null;
    }

    const [ stateAbbr ] = state ? getOptionsForHardcodedState(state) : [{}];
    
    return (
        <Fragment>
            <div className = 'grid-col-12' >
                <div className = 'grid-row' >
                    <SummaryItem
                        category = 'ssap.additional_info.summary.offered_employer_coverage'
                        value = { employerWillOfferInsuranceIndicator }
                        desc = {
                            [
                                [
                                    `taxHousehold.householdMember[${ idx }].healthCoverage.employerWillOfferInsuranceIndicator`
                                ]
                            ]
                        }
                    />
                </div>
            </div>
            
            {
                employerWillOfferInsuranceIndicator &&

                <SummaryFilter summaryId = { SsapSummaryType.EMPLOYER_COVERAGE_DETAILS }>
                    <EmployerCoverageDetails
                        { ...{
                            applicantGuid,
                            employerSponsoredCoverage,
                            householdMembers,
                            idx,
                            previousData
                        } }
                    />
                </SummaryFilter>
            }
            {
                stateHealthBenefit !== null &&

                <div className = 'grid-col-12' >
                    <div className = 'grid-row' >
                        <SummaryItem
                            category = 'ssap.additional_info.summary.state_employer_benefit'
                            replacements = { {
                                stateName: stateAbbr.text
                            } }
                            value = { stateHealthBenefit }
                            desc = {
                                [
                                    [
                                        `taxHousehold.householdMember[${ idx }].healthCoverage.stateHealthBenefit`
                                    ]
                                ]
                            }
                        />
                    </div>
                </div>
            }
        </Fragment>
    );
};

export default EmployerCoverageInfo;